/**
 * Content extraction size limits for document processing
 *
 * TODO: Make these configurable via:
 * - Environment variables (VITE_MAX_EXTRACTED_TEXT_SIZE)
 * - Admin settings panel
 * - Per-organization quotas
 */
export const CONTENT_LIMITS = {
  /**
   * Maximum extracted text size in bytes
   * Rationale: ~100 pages of text, prevents storing multi-MB documents
   * Impact: Documents exceeding this will be truncated with indicator
   */
  MAX_EXTRACTED_TEXT_SIZE: 500_000, // 500KB

  /**
   * Maximum rows to extract per Excel sheet
   * Rationale: Prevents million-row data dumps from audit systems
   * Impact: Only first N rows extracted, rest skipped with warning
   */
  MAX_EXCEL_ROWS_PER_SHEET: 10_000,

  /**
   * Maximum Excel sheets to process in a workbook
   * Rationale: Edge case protection for files with excessive sheets
   * Impact: Only first N sheets processed
   */
  MAX_EXCEL_SHEETS: 50,

  /**
   * Maximum file size (bytes) to attempt extraction on
   * Rationale: Large files cause memory issues and slow extraction
   * Impact: Files >10MB upload successfully but don't extract content
   */
  MAX_FILE_SIZE_FOR_EXTRACTION: 10_000_000, // 10MB

  /**
   * Convex document size hard limit (cannot exceed)
   * Reference: https://docs.convex.dev/database/document-storage#document-size-limits
   */
  CONVEX_DOCUMENT_SIZE_LIMIT: 1_000_000, // 1MB

  /**
   * Truncation indicator appended when content exceeds limits
   */
  TRUNCATION_INDICATOR: "\n\n[Content truncated due to size limits]",
} as const;

export type ContentLimitKey = keyof typeof CONTENT_LIMITS;
